// @flow
import React from "react";
import PropTypes from "prop-types";
import LazyLoad from "react-lazyload";
import _ from "lodash";
import Helper from "../../../../helper/Helper";
import CONFIG from "../../../../config/";
import I18n from "../../../../i18n/I18n";
import styles from "./OrderModal.scss";

const OrderModal = (props: Object) => {
  const selected = props.selected;
  const placeholder = (
    <img
      src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
      alt="placeholder"
    />
  );
  const orderList =
    selected && !_.isEmpty(selected)
      ? selected.map((order, index) => {
          return (
            <tr key={index}>
              <td>{order.itemNr}</td>
              <td>{order.idOffer}</td>
              <td>
                <div
                  className={`${styles.status} ${
                    styles[
                      order.itemStatus
                        .toLowerCase()
                        .split(" ")
                        .join("_")
                    ]
                  }`}
                >
                  {order.itemStatus}
                </div>
              </td>
            </tr>
          );
        })
      : "";
  return (
    <div className={styles.ctr}>
      <div className={styles.topWrapper}>
        {selected && !_.isEmpty(selected) ? (
          <div className={styles.imageWrapper}>
            <LazyLoad height="100%" once placeholder={placeholder} offset={100}>
              <img src={Helper.getTransformationUrl(selected[0].imagekey)} />
            </LazyLoad>
          </div>
        ) : (
          ""
        )}
        <div className={styles.descWrapper}>
          {selected && !_.isEmpty(selected) ? (
            <h4 className={styles.title}>{selected[0].itemName}</h4>
          ) : (
            ""
          )}
          <div className={styles.specs}>
            {selected && !_.isEmpty(selected) ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText(
                    "order-modal.product-price",
                    {},
                    "Product PRice"
                  )}
                </div>
                <div>
                  {I18n.formatCurrency(
                    Helper.formatPrice(selected[0].price, props.currencyCode)
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            {selected && !_.isEmpty(selected) ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText("order-modal.sku", {}, "SKU")}
                </div>
                <div>{selected[0].sku}</div>
              </div>
            ) : (
              ""
            )}
            {selected && !_.isEmpty(selected) ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText("order-modal.qty", {}, "QTY")}
                </div>
                <div>{selected[0].quantity}</div>
              </div>
            ) : (
              ""
            )}
            {selected && !_.isEmpty(selected) ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText("order-modal.total", {}, "TOtal")}
                </div>
                <div>
                  {I18n.formatCurrency(
                    Helper.formatPrice(
                      selected[0].itemTotal,
                      props.currencyCode
                    )
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            {selected && !_.isEmpty(selected) && selected[0].variant ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText("order-modal.variant", {}, "Variant")}
                </div>
                <div>{selected[0].variant}</div>
              </div>
            ) : (
              ""
            )}
            {selected &&
            !_.isEmpty(selected) &&
            selected[0].attributes &&
            !_.isEmpty(JSON.parse(selected[0].attributes)) &&
            JSON.parse(selected[0].attributes).colour_family ? (
              <div className={styles.eachSpec}>
                <div className={styles.specTitle}>
                  {I18n.getText("order-modal.color", {}, "Color")}
                </div>
                <div>{JSON.parse(selected[0].attributes).colour_family}</div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              <th>{I18n.getText("order-modal.item-no", {}, "Item No.")}</th>
              <th>{I18n.getText("order-modal.order-id", {}, "Order ID")}</th>
              <th>{I18n.getText("order-modal.status", {}, "Status")}</th>
            </tr>
          </thead>
          <tbody>{orderList}</tbody>
        </table>
      </div>
    </div>
  );
};

OrderModal.propTypes = {};

OrderModal.getDefaultProps = {};

export default OrderModal;



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/orderModal/OrderModal.js